import React from 'react';

// material-ui
import Typography from '@mui/material/Typography';

// project imports
import NavGroup from './NavGroup';
import { getMenuItems } from './../../../../menu-items';
import { useAccountType } from './../../../../contexts/AccountTypeContext';

//-----------------------|| SIDEBAR MENU LIST ||-----------------------//

const MenuList = () => {
    const { accountType } = useAccountType();
    const menuItem = getMenuItems(accountType);

    const navItems = menuItem.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return navItems;
};

export default MenuList;
